module.exports = __webpack_public_path__ + "img/ico-connection.a37f0b05.svg";